"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * This class mirrors EvaluationData in @expediagroup/egtnl-bucket.
 *
 * @see {@link https://github.expedia.biz/EGExperimentation/node-abacus/blob/master/API.md#EvaluationData|Evaluation Data docs}
 * @see {@link https://github.expedia.biz/EGExperimentation/node-abacus/blob/master/lib/experiment/evaluation-data.js|Evaluation Data code}
 */
var EvaluationData =
/**
 * Creates an EvaluationData object based on supplied context.
 *
 * @param {Object} context - experiment evaluation data
 */
function EvaluationData(context) {
    _classCallCheck(this, EvaluationData);

    if (context instanceof EvaluationData) {
        return context;
    }

    for (var attr in context) {
        if (context.hasOwnProperty(attr)) {
            this[attr] = context[attr];
        }
    }
};

exports.default = EvaluationData;
//# sourceMappingURL=EvaluationData.js.map